import Flickity from "flickity";

export default function Storiesblock() {
  Alpine.data("storiesblock", () => ({
    _flkty: null,
    canPrev: false,
    canNext: true,

    init() {
      const track = this.$el.querySelector("[data-track]");
      if (!track) return;

      requestAnimationFrame(() => {
        this._flkty = new Flickity(track, {
          cellAlign: "left",
          contain: true,
          wrapAround: false,
          pageDots: false,
          prevNextButtons: false,
          draggable: true,
          groupCells: true,
        });

        const updateNav = () => {
          this.canPrev = this._flkty.selectedIndex > 0;
          this.canNext =
            this._flkty.selectedIndex < this._flkty.slides.length - 1;
        };

        this._flkty.on("change", updateNav);
        updateNav();

        this._flkty.on("dragStart", () =>
          this._flkty.slider.childNodes.forEach(
            (slide) => (slide.style.pointerEvents = "none"),
          ),
        );
        this._flkty.on("dragEnd", () =>
          this._flkty.slider.childNodes.forEach(
            (slide) => (slide.style.pointerEvents = "all"),
          ),
        );

        var medias = this.$el.querySelectorAll("[data-media] > *");
        this._flkty.on("scroll", () => {
          this._flkty.cells.forEach((cell, i) => {
            var img = medias[i];

            if (!img || !cell.element.clientWidth) return;
            var x = cell.x + this._flkty.x;
            var progress = Math.min(1, Math.abs(x) / cell.element.clientWidth);
            var scale = 1 + progress * 0.2;

            img.children[0].style.transform = "scale(" + scale + ")";
          });
        });
      });
    },

    destroy() {
      if (this._flkty) {
        this._flkty.destroy();
        this._flkty = null;
      }
    },

    prev() {
      if (this._flkty) this._flkty.previous();
    },

    next() {
      if (this._flkty) this._flkty.next();
    },
  }));
}
